// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.editor-login-gate {
  min-height: calc(100vh - 60px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem 1rem 3rem;
  background: linear-gradient(180deg, #eef1f2 0%, #fdfaf2 100%);
}

.editor-login-gate__container {
  width: 100%;
  max-width: 560px;
}

.editor-login-gate__card {
  background: #fff;
  border-top-right-radius: 72px;
  border-bottom-left-radius: 72px;
  box-shadow: 0 18px 48px rgba(0, 0, 0, 0.08);
  padding: 3rem 2rem 2.5rem;
  text-align: center;
}

.editor-login-gate__icon-wrap {
  width: 72px;
  height: 72px;
  margin: 0 auto 1.25rem;
  border-radius: 999px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f8d4b7;
  color: #0e0e0e;
  font-size: 34px;
}

.editor-login-gate__eyebrow {
  margin: 0 0 0.5rem;
  font-size: 0.875rem;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #868b96;
}

.editor-login-gate__title {
  margin: 0 0 0.75rem;
  font-size: clamp(1.75rem, 4vw, 2.25rem);
  line-height: 1.15;
  color: #0e0e0e;
}

.editor-login-gate__text {
  margin: 0 auto 1.75rem;
  max-width: 420px;
  font-size: 1rem;
  line-height: 1.6;
  color: #555;
}

.editor-login-gate__actions {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  align-items: center;
}

.editor-login-gate__btn {
  min-width: 220px;
}

@media (max-width: 575px) {
  .editor-login-gate__card {
    border-top-right-radius: 48px;
    border-bottom-left-radius: 48px;
    padding: 2.25rem 1.25rem 2rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/EditorLoginGate.css"],"names":[],"mappings":"AAAA;EACE,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,6DAA6D;AAC/D;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,+BAA+B;EAC/B,2CAA2C;EAC3C,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,uCAAuC;EACvC,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;IACE,6BAA6B;IAC7B,+BAA+B;IAC/B,6BAA6B;EAC/B;AACF","sourcesContent":[".editor-login-gate {\n  min-height: calc(100vh - 60px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 2rem 1rem 3rem;\n  background: linear-gradient(180deg, #eef1f2 0%, #fdfaf2 100%);\n}\n\n.editor-login-gate__container {\n  width: 100%;\n  max-width: 560px;\n}\n\n.editor-login-gate__card {\n  background: #fff;\n  border-top-right-radius: 72px;\n  border-bottom-left-radius: 72px;\n  box-shadow: 0 18px 48px rgba(0, 0, 0, 0.08);\n  padding: 3rem 2rem 2.5rem;\n  text-align: center;\n}\n\n.editor-login-gate__icon-wrap {\n  width: 72px;\n  height: 72px;\n  margin: 0 auto 1.25rem;\n  border-radius: 999px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #f8d4b7;\n  color: #0e0e0e;\n  font-size: 34px;\n}\n\n.editor-login-gate__eyebrow {\n  margin: 0 0 0.5rem;\n  font-size: 0.875rem;\n  font-weight: 600;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: #868b96;\n}\n\n.editor-login-gate__title {\n  margin: 0 0 0.75rem;\n  font-size: clamp(1.75rem, 4vw, 2.25rem);\n  line-height: 1.15;\n  color: #0e0e0e;\n}\n\n.editor-login-gate__text {\n  margin: 0 auto 1.75rem;\n  max-width: 420px;\n  font-size: 1rem;\n  line-height: 1.6;\n  color: #555;\n}\n\n.editor-login-gate__actions {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n  align-items: center;\n}\n\n.editor-login-gate__btn {\n  min-width: 220px;\n}\n\n@media (max-width: 575px) {\n  .editor-login-gate__card {\n    border-top-right-radius: 48px;\n    border-bottom-left-radius: 48px;\n    padding: 2.25rem 1.25rem 2rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
